import * as React from "react";

interface ISwapButtonProps {
  height?: number | string;
  width?: number | string;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

export default class SwapButton extends React.PureComponent<ISwapButtonProps> {
  render() {
    return (
      <button
        type="button"
        className={
          "prveo-btn-svg prveo-btn-svg-primary " + this.props.className
        }
        onClick={this.props.onClick}
      >
        <svg
          style={{ height: this.props.height, width: this.props.width }}
          viewBox="0 0 64 64"
        >
          <path d="m10 26h39.172l-3.586 3.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586l7-7c.781-.781.781-2.047 0-2.828l-7-7c-.781-.781-2.047-.781-2.828 0s-.781 2.047 0 2.828l3.586 3.586h-39.172c-1.104 0-2 .896-2 2s.896 2 2 2z" />
          <path d="m54 38h-39.172l3.586-3.586c.781-.781.781-2.047 0-2.828-.78-.781-2.048-.781-2.828 0l-7 7c-.781.781-.781 2.047 0 2.828l7 7c.39.391.902.586 1.414.586s1.024-.195 1.414-.586c.781-.781.781-2.047 0-2.828l-3.586-3.586h39.172c1.104 0 2-.896 2-2s-.896-2-2-2z" />
        </svg>
      </button>
    );
  }
}
